import React, {useCallback, useEffect, useState, useRef} from "react";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import MatchInformations from "./MatchInformations/MatchInformations";
import { useTheme } from "../../contexts/theme";
import TransparentButton from "../CommonComponents/TransparentButton/TransparentButton";
import Grid from "@mui/material/Grid";
import StyledPopup from "../CommonComponents/StyledPopup/StyledPopup";
import axios from "../../queries/axiosInstance";
import { LoadError } from "../../types/generic";
import ErrorSnackBar from "../CommonComponents/ErrorSnackBar/ErrorSnackBar";
import EventForm from "./EventForm/EventForm";
import {DataSource, FileDataSource, Ftp, Stream, Track} from "../../types/dataSourceTypes";
import {DataJob, jobSSE} from "../../types/jobDataTypes";
import { getDefaultDataJob } from "../../utils/jobUtils"
import JobForm from "./JobForm/JobForm";
import {defaultEvent, EventData, GenericEventData} from "../../types/eventTypes";
import {createJobObject, formatDateFromString} from "../../utils/utils";
import { formatUTCDate } from "../../utils/dateTimeutils";
import SpinnerBox from "../CommonComponents/SpinnerBox/SpinnerBox";
import {Competition, defaultCompetition} from "../CommonComponents/OpenerCloserComponent/OpenerCloserComponent";
import {closeEventSource, getEventSource} from "../../queries/sseClient";
import StyledFloatingActionButton from "../CommonComponents/StyledFloatingActionButton/StyledFloatingActionButton";
import Drawer from "@mui/material/Drawer";
import {useSSEProvider} from "../../contexts/SSEProvider";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import {FormJob} from "../../types/jobTypes";
import {createStartJob, getJobById, updateJob} from "../../queries/jobQueries";

interface Match {
    title: string;
    matchDate: string;
    sharedWith: string[];
    // score: string;
    // half: string;
    jobMatch: JobMatch[];
    [key: string]: any;
}

interface JobMatch {
    id: string,
    name: string,
    description: string,
    extraction_schedule: string,
    status: string,
    source: string,
    target: string,
    tag: string[],
    settings: boolean,
    away_team: string,
    home_team: string,
    key_moment_type: string,
    score: string,
    half: string,
    last_event_time: string,
    last_run: string,
    numberClips: number,
    redCard: number,

}

interface PageData {
    [league: string]: { match: Match[] };
}


interface OptionForm {
    optionsTag: string[];
    protocol: string[];
    typeMediaTrack: string[];
    typeOfFile: string[];
    containerType: string[];
    typeEvent: "football";
    typeProviderDataFeed: string[];
    feedSourcesTypes: string[];
    feed_type: string[];
}

interface OptionsJobForm {
    dataSources: DataSource[];
    optionsTag: string[];
    targetJob: string[];
    idEvent: string;
}

interface MatchboardContentProps {
    pageData?: PageData;
    setPageData?: React.Dispatch<React.SetStateAction<PageData | undefined>>;
    options?: OptionForm;
    handleIdEventForNewJob: (id: string) => void,
    optionsjobForm?: OptionsJobForm,
    deleteMatch: (id: string) => void;
    updateMatch: (id: string) => void;
    handleGetEventForUpdateByID: (id: string) => Promise<EventData>;
    handleManageJob: (id: string, operation: string) => void;
    handleOptionJobForm: (value: OptionsJobForm) => void;
    onJobRefresh: () => void
}

const defaultJobData = getDefaultDataJob()

const MatchboardContent = ({pageData, options, setPageData, deleteMatch, updateMatch, handleOptionJobForm, optionsjobForm, handleIdEventForNewJob, handleGetEventForUpdateByID, handleManageJob, onJobRefresh }: MatchboardContentProps) => {
    const theme = useTheme();


    const [drawerOpen, setDrawerOpen] = useState<boolean>(false)
    const [UpdateEntity, setUpdateEntity] = React.useState<EventData | undefined>(undefined);
    const [loadingUpdateJobForm, setLoadingUpdateJobForm] = React.useState(false);
    const [loadingUpdateEntityForm, setLoadingUpdateEntityForm] = React.useState(true);
    const [loadingCreateForm, setLoadingCreateForm] = useState<boolean>(false);
    const [idEventUpdate, setIDEventUpdate] = React.useState<string>("");
    const [forceUpdate, setForceUpdate] = useState<boolean>(false);

    // opener-closer
    const [jobCompetition, setJobCompetition] = useState<Competition>(defaultCompetition)

    const { jobsRunning } = useSSEProvider();

    const [entity, setEntity] = useState<EventData>(defaultEvent);

    const [entityJobUpdate, setEntityJobUpdate] = useState<DataJob>(JSON.parse(JSON.stringify(defaultJobData)))

    const [entityJob, setEntityJob] = useState<DataJob>(
        JSON.parse(JSON.stringify(defaultJobData))
    )

    const [job, setJob] = useState<FormJob>(JSON.parse(JSON.stringify(defaultJobData)))
    const [jobFormMode, setJobFormMode] = useState<'create' | 'update'>('create')
    const [jobEventId, setJobEventId] = useState<string>('')


    const [loadError, setLoadError] = useState<LoadError>({ error: false, message: '' });
    const [isOpenDialog, setIsOpenDialog] = React.useState(false);
    const [dialogFormJob, setDialogFormJob] = useState(false);
    const [dialogFormUpdateJob, setDialogFormUpdateJob] = useState(false);
    const [openFormUpdate, setFormUpdate] = useState(false);
    const [idEventForNewJob, setIdEventForNewJob] = useState<string>("");
    const [idEventForUpdateJob, setIdEventUpdateJob] = useState<string>("");
    const [idJobDelete, setIdJobDelete] = useState<string>("");

    const runningJobsRef = useRef<jobSSE[] | null>(jobsRunning)

    const handleDrawer = (value: boolean) => {
        setDrawerOpen(value);
    }

    function handleJobFormClosure(){
        setIdEventForNewJob("");
        setJobCompetition(defaultCompetition);
        setDialogFormJob(false);
        setEntityJob(JSON.parse(JSON.stringify(defaultJobData)))
    }

    const onSubmit = useCallback(async (data: GenericEventData, mode: "create" | "update") => {
        if (mode === "create") {

            try {
                const response = await axios.post(process.env.REACT_APP_BASE_URL + '/match/createEvent' || '', {
                    name: data.name,
                    description: data.description,
                    tags: data.tags,
                    matchday: data.matchday,
                    typeEvent: data.typeEvent,
                    championship: data.championship,
                    event_start: data.event_start,
                    event_end: data.event_end,
                    dataSource: data.dataSource,
                    season: data.season,
                    home_team: data.home_team,
                    away_team: data.away_team,
                    venue: data.venue,
                    gameNumber: data.gameNumber,
                    external_id: "external_id" in data ? data.external_id : '',
                    match_type: data.match_type,
                    round_type: data.round_type
                });

                if (response.data === 'OK') {
                    setLoadError({ error: true, message: 'Event Created Successfully' });
                    setIsOpenDialog(false);
                }

            } catch (error) {
                console.error("Error to create event:", error);
                setLoadError({ error: true, message: 'Error to create event' });
            }
        } else if (mode === "update") {
            try {
                const response = await axios.put(process.env.REACT_APP_BASE_URL + `/match/updateEvent/${data.idEvent}` || '', {
                    idEvent: data.idEvent,
                    name: data.name,
                    description: data.description,
                    matchday: data.matchday,
                    tags: data.tags,
                    typeEvent: data.typeEvent,
                    championship: data.championship,
                    event_start: data.event_start,
                    event_end: data.event_end,
                    dataSource: data.dataSource,
                    season: data.season,
                    home_team: data.home_team,
                    away_team: data.away_team,
                    venue: data.venue,
                    gameNumber: data.gameNumber,
                    external_id: "external_id" in data ? data.external_id : '',
                    match_type: data.match_type,
                    round_type: data.round_type
                });

                if (response.data === 'OK') {
                    setLoadError({ error: true, message: 'Event Updated Successfully' });
                    setFormUpdate(false);
                }

            } catch (error) {
                console.error("Error to update event:", error);
                setLoadError({ error: true, message: 'Error to update event' });
            }
        }
    }, [setLoadError, setIsOpenDialog, setFormUpdate]);


    const handlingIdJobDelete = (idJob: string) => {
        setIdJobDelete(idJob);
    }


    const deleteJob = async () => {
        try {
            const responseDeleteJob = await axios.delete(process.env.REACT_APP_BASE_URL + `/job/deleteJob/${idJobDelete}`)
            setLoadError({ error: true, message: 'Job delete successfully' });
        } catch (error) {
            console.error(error);
            setLoadError({ error: true, message: 'Error to delete a job' });
        }
    }

    useEffect(() => {
        if (idJobDelete !== '') {
            deleteJob().then(r => {
            });
        }
    }, [idJobDelete]);

    useEffect(() => {
        handleOptionJobForm({
            idEvent: "",
            dataSources: [],
            optionsTag: [],
            targetJob: []
        })
    }, [idEventForNewJob]);

    async function handleJobCreation(){
        try{
            await createStartJob(job)
            setLoadError({ error: true, message: 'Job created successfully' });
        }catch (e) {
            setLoadError({ error: true, message: 'Error creating the job' });
        }finally {
            handleJobFormClosure()
        }
    }

    async function handleJobUpdate(){
        try{
            await updateJob(job);
            setLoadError({ error: true, message: 'Job updated successfully' });
        }catch (e) {
            setLoadError({ error: true, message: 'Error updating job' });
        }finally {
            handleJobFormClosure()
        }

    }

    useEffect(() => {
        if(pageData && (dialogFormJob)) {
            const competitionFormId = jobEventId
            for(const competition of Object.keys(pageData)) {
                const competitionMatches = pageData[competition].match;
                const foundCompetition = competitionMatches.find((competitionMatch: any) => competitionMatch.id === competitionFormId);
                if(foundCompetition) {
                    setJobCompetition({name: foundCompetition.competition, id: foundCompetition.competition_id, type: "", season: ""})
                    return
                }
            }
        } else {
            setJobCompetition(defaultCompetition)
        }
    }, [pageData, dialogFormJob, dialogFormUpdateJob, idEventForUpdateJob, idEventForNewJob]);

    const handleSetMatchData = (league: string, updatedMatches: Match[]) => {
        if (pageData && setPageData) {
            setPageData({
                ...pageData,
                [league]: {
                    match: updatedMatches
                }
            });
        }
    };

    const handleDeleteMatch = (id: string) => {
        deleteMatch(id);
    }

    const updateIdEventForNewJob = (id: string) => {
        setIdEventForNewJob(id);
        handleIdEventForNewJob(id);
        setDialogFormJob(true);
    }

    const handleUpdateEvent = (id: string) => {
        setFormUpdate(true);
        setIDEventUpdate(id);
        setForceUpdate(prev => !prev); // Cambia il flag per forzare l'esecuzione del useEffect
    }

    useEffect(() => {
        if (idEventUpdate !== "") {
            setLoadingUpdateEntityForm(true);

            const promises : Promise<any>[] = []

            promises.push(handleGetEventForUpdateByID(idEventUpdate));
          //  promises.push(fetchFtpData());

            Promise.all(promises)
                .then(([tempEvent]) => {

                    if (tempEvent !== undefined) {
                        setUpdateEntity(tempEvent);
                    }else{
                        setFormUpdate(false);
                        setLoadError({ error: true, message: 'Error retrieving event' });
                    }

                })
                .catch((error) => {
                    console.error('Errore nel recupero dei dati:', error);

                }).finally(() => {
                setLoadingUpdateEntityForm(false)
            });


        }


    }, [idEventUpdate, forceUpdate]);

    const handleGetIdForNewJob = async (idJob: string, idEvent: string) => {
        setLoadingUpdateJobForm(true);
        setDialogFormJob(true);
        setJobFormMode('update');
        setJobEventId(idEvent)


        const job = await getJobById(idJob);

        if (job !== undefined) {

            for (const eventOfInterest of entityJobUpdate.settings.events_of_interest) {
                const attualEventOfInterest = job.settings.events_of_interest.find(item => item.key_moment === eventOfInterest.key_moment);
                if (attualEventOfInterest) {
                    for (const eventKey in eventOfInterest) {
                        (eventOfInterest as any)[eventKey] = (attualEventOfInterest as any)[eventKey];
                    }
                } else {
                    eventOfInterest.included = false;
                }
            }

            for (const skills of entityJobUpdate.settings.skills) {
                const actualSkills = job.settings.skills.find(item => item.key_moment === skills.key_moment);
                if (actualSkills) {
                    for (const skillKey in skills) {
                        (skills as any)[skillKey] = (actualSkills as any)[skillKey];
                    }
                } else {
                    skills.included = false;
                }
            }
            job.settings.events_of_interest = entityJobUpdate.settings.events_of_interest
            job.settings.skills = entityJobUpdate.settings.skills
            setJob(job)
            handleIdEventForNewJob(idEvent);
            setIdEventUpdateJob(idEvent);
        }
        setLoadingUpdateJobForm(false);
    }



    const fetchJobById = async (idJob: string) => {
        try {
            const responseJob = await axios.get(process.env.REACT_APP_BASE_URL + `/match/getJobByID/${idJob}`);
            const job: DataJob = {
                idJob: responseJob.data.id,
                name: responseJob.data.name,
                description: responseJob.data.description,
                extraction_schedule: responseJob.data.extraction_schedule,
                push_schedule: responseJob.data.push_schedule,
                job_base_folder: responseJob.data.job_base_folder,
                llm_generation: responseJob.data.llm_generation,
                tag: responseJob.data.tag,
                target: responseJob.data.target,
                settings: responseJob.data.settings,
                data_sources: responseJob.data.data_sources,
                tracks: responseJob.data.tracks,
                events: responseJob.data.events,
                opener: responseJob.data.opener,
                closer: responseJob.data.closer,
                hooks: responseJob.data.hooks,
                kafka_hook: responseJob.data.kafka_hook
            }



            return job;
        } catch (errorJob) {
            {
                console.error("Error get Job: ", JSON.stringify(errorJob));
            }
        }
    }

/*
    useEffect(() => {

        const SSE_URL = process.env.REACT_APP_BASE_URL + `/sse/events`;

        const es = getEventSource(SSE_URL)
        if (es) {
            es.addEventListener('message', async (event) => {
                const data = JSON.parse(event.data);
                console.log('Dato ricevuto:', data);
            })

            es.addEventListener('error', async (event) => {
                console.error('Errore SSE:', event);

            })


            return () => {
                es.removeEventListener('message', async (event) => {
                    const data = JSON.parse(event.data);
                    console.log('Dato ricevuto:', data);
                })

                es.removeEventListener('error', async (event) => {
                    console.error('Errore SSE:', event);
                })

                closeEventSource(); // 🔒 chiusura socket automatica su unmount

            };
        }
    }, []);*/




    function wrappedEventForNewJob(eventId: string){
        updateIdEventForNewJob(eventId);
        setJobFormMode('create');
        const tempJob = JSON.parse(JSON.stringify(defaultJobData))
        tempJob.events = {id: eventId}
        setJob(tempJob)
        setJobEventId(eventId)
    }

    useEffect(() => {
        runningJobsRef.current = jobsRunning


    }, [jobsRunning]);

    function getSSEJobEventName(job: jobSSE){
        if (job.type === 'editing'){
            return job.events.length > 0 ? job.events[0].name : ""
        }
        else if (job.type === 'highlight-on-demand'){
            return job.name
        }
    }

    return (



        <Box style={{ borderRadius: theme.border.radius.md }}>



            <ErrorSnackBar autoHideDuration={5000} open={loadError.error} setClose={() => setLoadError({ message: '', error: false })} errorMessage={loadError.message} />

            {isOpenDialog &&

                <StyledPopup isOpen={true} onClose={() => setIsOpenDialog(false)} title='New Event' fullWidth={false} width='50%'>
                    <>
                        <EventForm entity={entity} openForm={isOpenDialog} onSubmit={onSubmit} optionsForm={options!} mode={"create"}  />
                        </>


                </StyledPopup>}
            <StyledPopup isOpen={openFormUpdate} onClose={() => {setFormUpdate(false); setLoadingUpdateEntityForm(true); setUpdateEntity(undefined)}} title={UpdateEntity && UpdateEntity.name ? (UpdateEntity.name + " " + ((UpdateEntity && UpdateEntity?.event_start !== undefined ) ? (UpdateEntity?.event_start.toString() === "ND" ? "" : formatUTCDate(UpdateEntity?.event_start.toString(), false)) : "")):""} fullWidth={false} width='50%'>
                { loadingUpdateEntityForm ?
                    <SpinnerBox height={'50vh'} text={'Loading'} /> :

                    UpdateEntity && !loadingUpdateEntityForm && (
                    <EventForm entity={UpdateEntity!} onSubmit={onSubmit} optionsForm={options} mode={"update"} openForm={openFormUpdate} />
                    )
                }
            </StyledPopup>





            {dialogFormJob && (
                <StyledPopup isOpen={dialogFormJob} onClose={handleJobFormClosure} title={jobFormMode === 'create' ? "Create Job" : "Update Job"} fullWidth={false} width={'70%'}>
                    <JobForm
                        eventId={jobEventId}
                        job={job}
                        onSubmit={jobFormMode === 'create' ? handleJobCreation : handleJobUpdate}
                        setJob={setJob}
                        mode={jobFormMode}
                        competition={jobCompetition}
                        jobLoading={loadingUpdateJobForm}
                    />
                </StyledPopup>
            )}

            <Grid container direction="row" style={{ height: '100%' }}>
                <Box width={'100%'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <TransparentButton text='New Event' width='150px' onClick={() => {setIsOpenDialog(true);}} />
                    <TransparentButton text='Refresh' width='150px' onClick={onJobRefresh} />
                </Box>
            </Grid>

            {pageData && Object.entries(pageData).map(([league, { match }]) => (
                <Accordion
                    key={league}
                    defaultExpanded
                    style={{
                        backgroundColor: "transparent",
                        boxShadow: 'none',
                        marginBottom: theme.spacing.none
                    }}
                >


                    <AccordionSummary style={{ paddingLeft: theme.spacing.none, paddingRight: theme.spacing.none }} aria-controls={`${league}-content`} id={`${league}-header`}>
                        <Typography style={{ color: theme.palette.white, fontSize: theme.fontSizes.pageTitle, fontWeight: theme.fontWeights.pageTitle }}>{league}</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ padding: theme.spacing.none, paddingTop: 0 }}>
                        <MatchInformations handleFormUpdateMatch={handleUpdateEvent} match={match} updateMatch={updateMatch} idEventForNewJob={wrappedEventForNewJob} deleteMatch={handleDeleteMatch} setMatchData={(updatedMatches) => handleSetMatchData(league, updatedMatches)} handleManageJob={handleManageJob} handleGetIdForNewJob={handleGetIdForNewJob} deletingJobById={handlingIdJobDelete} />
                    </AccordionDetails>
                </Accordion>
            ))}


            <Drawer
                color={theme.palette.blue}
                anchor={'right'}
                open={drawerOpen}
                onClose={()=>handleDrawer(false)}

                sx={{
                    "& .MuiDrawer-paper": {
                        backgroundColor: theme.palette.blue, // colore di sfondo
                    },
                }}
            >
                <Box sx={{
                    backgroundColor: theme.palette.blue,
                    padding: theme.spacing.md,
                    width: "400px"
                }}>
                    <Typography>
                        {
                            runningJobsRef.current!.map((job,index)=>(
                                <Card
                                    sx={{
                                        backgroundColor: theme.palette.blue,
                                        boxShadow: 24,         // aggiunge ombra (0-24, più alto = più intensa)
                                        borderRadius: 2,      // angoli leggermente arrotondati (opzionale)
                                        marginBottom: theme.spacing.md,      // spazio sotto ogni card
                                    }}
                                >
                                    <CardContent sx={{ height: "100%", marginBottom: theme.spacing.xs }}>

                                        <Typography variant="body1" color={theme.palette.white}>
                                            <Box component="span" fontWeight="bold">Type:</Box> {job.type}
                                        </Typography>

                                        <Typography variant="body1" color={theme.palette.white}>
                                            <Box component="span" fontWeight="bold">Status:</Box> {job.status}
                                        </Typography>

                                        {job.last_state_change && <Typography variant="body1" color={theme.palette.white}>
                                            <Box component="span" fontWeight="bold">Last Change:</Box> {job.last_state_change ? formatDateFromString(job.last_state_change) : ""}
                                        </Typography>}

                                        {job.events.length > 0 &&
                                        <Typography variant="body1" component="div" color={theme.palette.white}>
                                            <Box component="span" fontWeight="bold">Event:</Box> {getSSEJobEventName(job)}
                                        </Typography>
                                        }

                                        {job.events.length > 0 && job.events[0].competition &&
                                        <Typography variant="body1" component="div" color={theme.palette.white}>
                                            <Box component="span" fontWeight="bold">Competition:</Box> {job.events.length > 0 && job.events[0].competition ? job.events[0].competition.name : ""}
                                        </Typography>}

                                        {job.events.length > 0 && job.events[0].competition &&
                                        <Typography variant="body1" component="div" color={theme.palette.white}>
                                            <Box component="span" fontWeight="bold">Season:</Box> {job.events.length > 0 && job.events[0].competition ? job.events[0].competition.season : ""}
                                        </Typography>}

                                        {job.events.length > 0 && job.events[0].start_schedule &&
                                        <Typography variant="body1" component="div" color={theme.palette.white}>
                                            <Box component="span" fontWeight="bold">Start:</Box> {job.events.length > 0 && job.events[0].start_schedule ? formatDateFromString(job.events[0].start_schedule) : ""}
                                        </Typography>}

                                        {job.settings.aspect_ratio &&
                                        <Typography variant="body1" component="div" color={theme.palette.white}>
                                            <Box component="span" fontWeight="bold">Aspect Ratio:</Box> {job.settings.aspect_ratio}
                                        </Typography>
                                        }

                                        {job.settings.resolution &&
                                            <Typography variant="body1" component="div" color={theme.palette.white}>
                                                <Box component="span" fontWeight="bold">Resolution:</Box> {job.settings.resolution}
                                            </Typography>
                                        }

                                        {job.production_pixel_format &&
                                            <Typography variant="body1" component="div" color={theme.palette.white}>
                                                <Box component="span" fontWeight="bold">Production Pixel Format:</Box> {job.production_pixel_format}
                                            </Typography>
                                        }

                                        {job.settings.pix_fmt &&
                                            <Typography variant="body1" component="div" color={theme.palette.white}>
                                                <Box component="span" fontWeight="bold">Production Pixel Format</Box> {job.settings.pix_fmt}
                                            </Typography>
                                        }

                                        {job.settings.input_video_type &&
                                            <Typography variant="body1" component="div" color={theme.palette.white}>
                                                <Box component="span" fontWeight="bold">Input Video Type</Box> job.settings.input_video_type
                                            </Typography>
                                        }

                                    </CardContent>
                                </Card>
                            ))
                        }
                    </Typography>
                </Box>

            </Drawer>

            <StyledFloatingActionButton text={"Running Jobs: " + runningJobsRef.current!.length} onClick={()=>{handleDrawer(!drawerOpen)}}></StyledFloatingActionButton>
        </Box>
    );
}

export default MatchboardContent;